/**
 * A price as a restaurateur reads it: grouped thousands, no decimals. The
 * catalog and the payment endpoints both deal in whole dirhams, so the only
 * thing left to decide is the grouping, and that follows the active language.
 */
export const formatPrice = (amount: number, language: string): string =>
  amount.toLocaleString(language, { maximumFractionDigits: 0 });
